import { ArrowUpRight, Mountain, Bed, Utensils, Leaf } from "lucide-react";
import { useTranslation } from "react-i18next";
import { APUSENI_BG } from "../../data/experiences";
import { LocalizedLink } from "../../lib/i18nRouting";
import Reveal from "../Reveal";

const PILLAR_KEYS = ["trails", "lodging", "meals", "wellness"];
const ICONS = { trails: Mountain, lodging: Bed, meals: Utensils, wellness: Leaf };

export default function ApuseniSection() {
  const { t } = useTranslation();
  return (
    <section className="relative bg-forest-deep text-bone overflow-hidden" data-testid="apuseni-section">
      <div className="absolute inset-0">
        <img src={APUSENI_BG} alt={t("apuseni_home.title_b")} loading="lazy" decoding="async" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-forest-deep via-forest-deep/95 to-forest-deep" />
        <div className="absolute inset-0 grain" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-32 lg:py-44">
        <Reveal className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-20">
          <div className="md:col-span-8">
            <div className="text-xs uppercase tracking-wider-3 text-bone/70 mb-6 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-bone/60" />
              {t("apuseni_home.eyebrow")}
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-8xl leading-[1.02]">
              {t("apuseni_home.title_a")} <span className="italic">{t("apuseni_home.title_b")}</span>.
            </h2>
          </div>
          <div className="md:col-span-4 text-bone/75 text-base leading-relaxed md:pb-3">
            {t("apuseni_home.subtitle")}
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {PILLAR_KEYS.map((k, i) => {
            const Icon = ICONS[k];
            return (
              <Reveal key={k} delay={i * 100} className="border border-bone/15 p-8 hover:bg-bone/5 transition-colors duration-500">
                <Icon className="w-6 h-6 stroke-[1.25] opacity-80" />
                <div className="mt-8 text-xs uppercase tracking-wider-2 opacity-70">0{i+1}</div>
                <div className="font-display text-2xl mt-2">{t(`apuseni_home.pillars.${k}`)}</div>
              </Reveal>
            );
          })}
        </div>

        <Reveal className="mt-20">
          <LocalizedLink
            to="/apuseni"
            data-testid="apuseni-cta"
            className="btn-lift inline-flex items-center gap-3 border border-bone/60 px-8 py-4 text-xs uppercase tracking-wider-3 hover:bg-bone hover:text-forest"
          >
            {t("apuseni_home.cta")} <ArrowUpRight className="w-4 h-4" />
          </LocalizedLink>
        </Reveal>
      </div>
    </section>
  );
}
